import { render } from "./PageCallAction.vue?vue&type=template&id=a41df9f6&scoped=true"
import script from "./PageCallAction.vue?vue&type=script&lang=js"
export * from "./PageCallAction.vue?vue&type=script&lang=js"

import "./PageCallAction.vue?vue&type=style&index=0&id=a41df9f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a41df9f6"]])

export default __exports__